import {Attributes, Card} from 'platform/components';

import {useSelector} from 'react-redux';

import {selectTenant} from '@dms/api/core';
import i18n from '@dms/i18n';
import {selectCountry, selectCurrency} from '@dms/teas';

export const SystemInformation = () => {
  const {data: {id: tenantId, country: tenantCountry, currency: tenantCurrency} = {}} =
    useSelector(selectTenant);

  const country = useSelector(selectCountry(tenantCountry));
  const currency = useSelector(selectCurrency(tenantCurrency));

  return (
    <Card title={i18n.t('page.settings.labels.systemInformation')}>
      <Attributes
        size="quarter"
        rows={[
          {
            label: i18n.t('page.settings.labels.tenantLocation'),
            value: country?.name ?? '–',
          },
          {
            label: i18n.t('page.settings.labels.primaryCurrency'),
            value: currency?.name ?? '–',
          },
          {
            label: i18n.t('general.labels.currencySymbol'),
            value: currency?.symbol ?? '–',
          },
          {
            label: i18n.t('page.settings.labels.tenantId'),
            value: tenantId,
          },
        ]}
      />
    </Card>
  );
};
